import Form from 'react-bootstrap/Form';
import React from 'react';

const TitleBarToggle = ({ onToggle, defaultValue=false, classname="", preLabel="", label="", }) => {

    return (
        <Form>
            <Form.Group className={'d-flex '+classname}>
                <label className='me-2'>{preLabel}</label>
                <Form.Switch 
                    id="user-mode-switch"
                    label={label}
                    onChange={onToggle}
                    defaultChecked={defaultValue}
                />
            </Form.Group>
        </Form>
    );
};

export default TitleBarToggle;